import httpClient from "@/components/utils/httpClient";

const MixpanelService = {
  track: (prospect_id, event, properties = {}) => {
    if (!event) return;
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    httpClient
      .post(
        `/api/events`,
        { prospect_id, event, properties },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": token,
            Accept: "application/json",
          },
        },
      )
      .then(() => {});
  },
};

export default MixpanelService;
